import React from "react";
import iconMap from "utils/iconMap";

const FolderIcon = iconMap["folder"];

/**
 * FolderColorPicker
 * @param {Array} colors - Tableau d'objets { BCO_ID, BCO_NAME, BCO_HEX }
 * @param {string} selectedColor - Couleur hexadécimale sélectionnée
 * @param {function} onChange - Callback appelé avec la nouvelle couleur sélectionnée (hex, colorId)
 * @param {string} className - (optionnel) classes CSS supplémentaires
 */
const FolderColorPicker = ({ colors = [], selectedColor, onChange, className = "" }) => {
    return (
        <div className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 ${className}`}>
            {colors.map((color) => (
                <button
                    key={color.BCO_ID}
                    type="button"
                    onClick={() => onChange(color.BCO_HEX, color.BCO_ID)}
                    className={`
                        relative group
                        flex flex-col items-center
                        p-3 rounded-xl
                        transition-all duration-300 ease-in-out
                        hover:bg-gray-50 dark:hover:bg-gray-800
                        focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2
                        ${selectedColor === color.BCO_HEX ? 'bg-orange/10 dark:bg-orange/20' : ''}
                    `}
                    title={color.BCO_NAME}
                >
                    <div className="relative">
                        <FolderIcon
                            className="size-12 transition-all duration-300 ease-in-out
                                     group-hover:scale-110 group-hover:rotate-3
                                     drop-shadow-lg"
                            style={{ 
                                fill: color.BCO_HEX,
                                stroke: selectedColor === color.BCO_HEX ? '#FF7A00' : 'transparent',
                                strokeWidth: 2
                            }}
                        />
                        {selectedColor === color.BCO_HEX && (
                            <div className="absolute -top-1 -right-1 bg-orange text-white rounded-full p-1">
                                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                        )}
                    </div>
                    <span className="mt-2 text-sm font-medium text-gray-700 dark:text-gray-300 text-center max-w-[80px] truncate">
                        {color.BCO_NAME}
                    </span>
                </button>
            ))}
        </div>
    );
};

export default FolderColorPicker; 